export interface IecMarkProps {
	/** 48 в шапке desktop, 32 в мобильной шапке (макет 4c). */
	size?: number;
	alt: string;
	className?: string;
}

/** Знак IEC. Файл лежит в `public/`, потому что он общий для всех экранов входа. */
export function IecMark({ size = 48, alt, className }: IecMarkProps) {
	return (
		<img
			src="/mark-globe.svg"
			width={size}
			height={size}
			alt={alt}
			// `block` классом, а не инлайн-стилем: инлайновый display перебивает
			// утилиту `hidden`, и адаптивная пара «мобильный/десктопный знак»
			// показывалась одновременно.
			className={["block", className].filter(Boolean).join(" ")}
		/>
	);
}
